'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

import { AnalyticsService } from './AnalyticsService';

export default function Analytics({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  useEffect(() => {
    AnalyticsService.trackPageView(pathname ?? '');
  }, [pathname]);

  return <>{children}</>;
}
